import * as React from 'react';
import { FC } from 'react';

interface DirectionArrowProps {
  svgId: string;
  pathId: string;
}

const DirectionArrow: FC<DirectionArrowProps> = ({ svgId, pathId }) => {
  return (
    <svg id={svgId} width="122" height="140" viewBox="0 0 165 142" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        id={pathId}
        d="M40.6597 32.7242C31.1186 23.5233 15.9251 23.7991 6.7242 33.3403C-2.47672 42.8814 -2.2009 58.0749
             7.34027 67.2758L40.6597 32.7242ZM83.6992 107.57L67.0395 124.846L84.0045 141.206L100.67 124.541L83.6992
              107.57ZM157.238 67.9724C166.611 58.5998 166.611 43.4039 157.238 34.0313C147.866 24.6587
               132.67 24.6587 123.297 34.0313L157.238 67.9724ZM59.6831 107.551C59.6811 120.806 70.4246
                131.553 83.6794 131.555C96.9343 131.557 107.681 120.813 107.683 107.558L59.6831
                 107.551ZM7.34027 67.2758L67.0395 124.846L100.359 90.2945L40.6597 32.7242L7.34027
                  67.2758ZM100.67 124.541L157.238 67.9724L123.297 34.0313L66.7287 90.5997L100.67
                   124.541ZM59.6992 0.996364L59.6831 107.551L107.683 107.558L107.699 1.00364L59.6992 0.996364Z"
        fill="#ff56f6"
        stroke="#ff56f6"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6435_35923"
          x1="46.8271"
          y1="0.99989"
          x2="105.8"
          y2="68.2998"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF56F6" />
          <stop offset="0.348958" stopColor="#B936EE" />
          <stop offset="0.702463" stopColor="#3BACE2" />
          <stop offset="1" stopColor="#406AFF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default DirectionArrow;
